import Vue from 'vue';
import { isElectronContext } from './isElectron';
import { getDebugMacAddress } from './queryUtil';

let isElectron = isElectronContext();

let electron;
if (isElectron) {
  electron = window.require && window.require('electron');
}

export const printer = {
  print,
  printCard,
  getMachineInfo,
};

Vue.prototype.$printer = printer;
Vue.prototype.$isElectron = isElectron;

function print(text, callBack) {
  if (isElectron && electron) {
    const ipc = electron.ipcRenderer;
    ipc.send('print-zebra', text);
    ipc.on('print-reply', (event, arg) => {
      console.log(arg);
      if (callBack !== undefined) {
        callBack(arg);
      }
    });
  }
}

function printCard(data) {
  if (isElectron && electron) {
    const ipc = electron.ipcRenderer;
    ipc.send('print-card', data);
  }
}

function getMachineInfo() {
  const debugMacAddress = getDebugMacAddress;
  if (debugMacAddress) {
    return debugMacAddress;
  }
  if (isElectron && electron) {
    const ipc = electron.ipcRenderer;
    return ipc.sendSync('get-info', '');
  }
}
